<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="title" id="_idParaDest-1">The Reluctant Swordsman</h1>
<h2 class="subtitle">The Seventh Sword Series: Book One</h2>
<p class="author">Dave Duncan</p>
<p class="colophon _idGenParaOverride-1"><img alt="" class="_idGenPageitem-1" src="image/logo.jpg"/></p>
<p class="center"><em class="em">The Seventh Sword</em></p>
<p class="center">is fondly dedicated to</p>
<p class="center">JENNI and JUDY</p>
<p class="center">who had patience, love, and understanding</p>
<p class="center _idGenParaOverride-1">for a father with such strange unworldly ideas.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ReluctantSwordsman.vue?2a3c45c1